var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSectional(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 26",
    enableBackground: "new 0 0 37 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h9v6H0zM14 0h9v6h-9zM28 0h9v6h-9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10h9v6H0zM14 10h9v6h-9zM28 10h9v6h-9z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20h9v6H0zM14 20h9v6h-9zM28 20h9v6h-9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectional);
export default __webpack_public_path__ + "static/media/sectional.273e8205cc7c1148cc4df212ea533bec.svg";
export { ForwardRef as ReactComponent };